import { render, staticRenderFns } from "./MedicalCenterForm.vue?vue&type=template&id=62c5e725&"
import script from "./MedicalCenterForm.vue?vue&type=script&lang=js&"
export * from "./MedicalCenterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports